'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const SupportChartInner = dynamic(() => import('./SupportChartInner'), { ssr: false });

const summary = [
  { id: 'st-open', label: 'Open', value: 142, color: 'text-negative', bg: 'bg-negative/10' },
  { id: 'st-pending', label: 'Pending', value: 87, color: 'text-warning', bg: 'bg-warning/10' },
  { id: 'st-resolved', label: 'Resolved', value: 634, color: 'text-positive', bg: 'bg-positive/10' },
];

export default function SupportTicketWidget() {
  return (
    <div className="card-surface p-5">
      <div className="mb-4">
        <h2 className="text-base font-semibold text-foreground">Support Tickets</h2>
        <p className="text-sm text-muted-foreground">Volume by category — this week</p>
      </div>
      <div className="flex gap-3 mb-4">
        {summary?.map((s) => (
          <div key={s?.id} className={`flex-1 rounded-lg p-3 ${s?.bg}`}>
            <p className={`text-lg font-bold tabular-nums ${s?.color}`}>{s?.value}</p>
            <p className="text-xs text-muted-foreground font-medium">{s?.label}</p>
          </div>
        ))}
      </div>
      <SupportChartInner />
    </div>
  );
}